import React from 'react';

/**
 * Page header for the older screens. Keeps the original props (mainTitle, parent, subParent, title)
 * so existing pages don't change, but renders the new portal header: one clear title and a quiet trail.
 */
const Breadcrumbs = ({ mainTitle, parent, subParent, title }) => {
  const trail = [parent, subParent, title].filter((t) => t && t !== mainTitle);
  return (
    <header className='ed-legacy-head'>
      <h1>{mainTitle || title}</h1>
      {trail.length > 0 && <p>{trail.join(' / ')}</p>}
    </header>
  );
};

export default Breadcrumbs;
